export const enum CreditRequestStatus {
  Pending = 0,
  Review = 1,
  Complete = 2
}

export enum CreditRequestReasonEnum {
  None = 0,
  Damaged = 1,
  Short = 2,
  Other = 3
}